import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus, Trash2, Pencil, Eye } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { PageHeader, Empty } from "@/components/Common";
import { SalesFilter } from "@/components/SalesFilter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MaintPdfPreview } from "@/components/MaintProposal";

const rp = (v) => `Rp ${Math.round(v || 0).toLocaleString("id-ID")}`;

export default function Maintenance() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [sales, setSales] = useState("");
  const [kw, setKw] = useState("");
  const [pv, setPv] = useState(null);
  const load = () => api.get("/maintenance", { params: { sales_id: sales } }).then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [sales]); // eslint-disable-line react-hooks/exhaustive-deps
  const list = useMemo(() => rows.filter((r) => `${r.ms_no} ${r.customer_name} ${r.building}`.toLowerCase().includes(kw.toLowerCase())), [rows, kw]);
  const del = async (r) => {
    if (!window.confirm(`Hapus ${r.ms_no}?`)) return;
    try { await api.delete(`/maintenance/${r.id}`); toast.success("Dihapus"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="maint-page">
      <PageHeader title="Maintenance" subtitle="Kalkulasi HPP maintenance, harga per tahun, dan proposal kontrak maintenance (Backup / Non-Backup).">
        <Input className="w-64 bg-white" placeholder="Cari nomor / customer / gedung" value={kw} onChange={(e) => setKw(e.target.value)} data-testid="maint-search-input" />
        <SalesFilter value={sales} onChange={setSales} />
        <Button onClick={() => nav("/maintenance/new")} data-testid="maint-new-btn"><Plus className="h-4 w-4 mr-1" />Maintenance Baru</Button>
      </PageHeader>
      <div className="card-premium overflow-hidden">
        <table className="tbl w-full text-sm" data-testid="maint-table">
          <thead><tr><th>No.</th><th>Customer / Gedung</th><th>Status</th><th>Opsi</th><th className="text-right">Harga / Tahun</th><th className="text-right">Margin</th><th>Sales</th><th>Tanggal</th><th /></tr></thead>
          <tbody>
            {list.map((r, i) => {
              const o = r.calc.options.find((x) => x.key === `${r.selected?.period}${r.selected?.backup ? "b" : "n"}`);
              const prop = r.status === "proposal";
              return (
                <tr key={r.id} className="cursor-pointer hover:bg-slate-50" onClick={() => nav(`/maintenance/${r.id}`)} data-testid={`maint-row-${i}`}>
                  <td className="font-num font-semibold text-blue-800">{r.ms_no}</td>
                  <td><span className="font-medium">{r.customer_name}</span><span className="block text-xs text-slate-500">{r.building}</span></td>
                  <td><span className={`rounded px-2 py-0.5 text-xs font-bold ${prop ? "bg-emerald-100 text-emerald-800" : "bg-amber-100 text-amber-800"}`}>{prop ? "Proposal" : "Kalkulasi"}</span></td>
                  <td className="text-xs">{prop ? `${r.selected.backup ? "Backup" : "Non-Backup"} • ${r.selected.period} bln` : "-"}</td>
                  <td className="text-right font-num">{o ? rp(o.price) : "-"}</td>
                  <td className="text-right font-num">{o ? `${o.margin.toFixed(1)}%` : "-"}</td>
                  <td className="text-xs">{r.sales_name}</td>
                  <td className="text-xs">{fdate(r.created_at)}</td>
                  <td onClick={(e) => e.stopPropagation()} className="whitespace-nowrap">
                    {prop && <Button size="icon" variant="ghost" title="Preview PDF" onClick={() => setPv(r)} data-testid={`maint-preview-${i}`}><Eye className="h-4 w-4 text-rose-600" /></Button>}
                    <Button size="icon" variant="ghost" title="Edit" onClick={() => nav(`/maintenance/${r.id}`)} data-testid={`maint-edit-${i}`}><Pencil className="h-4 w-4" /></Button>
                    <Button size="icon" variant="ghost" title="Hapus" onClick={() => del(r)} data-testid={`maint-delete-${i}`}><Trash2 className="h-4 w-4 text-rose-500" /></Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {!list.length && <Empty />}
      </div>
      <MaintPdfPreview m={pv} open={!!pv} onOpenChange={(o) => !o && setPv(null)} />
    </div>
  );
}
